import classNames from "classnames";
import React from "react";
import "./tag.scss";

export type TTag = {
    text: string;
    theme?: "brand-blue" | "bright-blue" | "light-blue" | "yellow" | "success-light" | "grey" | "danger";
    size?: "mini" | "small" | "medium";
    className?: string;
    disabled?: boolean;
};

export const Tag = ({ text, theme = "brand-blue", size = "small", className, disabled = false }: TTag) => {
    return (
        <div className={classNames(`c-tag c-tag--${theme} c-tag--${size}`, className, { "c-tag--disabled": disabled })}>
            <span>{text}</span>
        </div>
    );
};
